// react-router context, not to be confused with React context

import { type QueryClient } from "@tanstack/react-query";
import { createContext, RouterContextProvider } from "react-router";

import { queryClient } from "../../api/queryClient.ts";

const queryClientContext = createContext<QueryClient>();

export const getContext: () => RouterContextProvider = () => {
  const result = new RouterContextProvider();
  result.set(queryClientContext, queryClient);
  return result;
};

export const getQueryClient = (context: Readonly<RouterContextProvider>): QueryClient =>
  context.get(queryClientContext);
